import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export default function useOrdersInvalidation(nftId?: string) {
  const queryClient = useQueryClient();

  function timeout(fn: () => void, delay = 0) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(fn());
      }, delay),
    );
  }

  return useCallback(
    async (delay = 0) => {
      await timeout(() => {
        queryClient.invalidateQueries(["nft", nftId]);
        queryClient.invalidateQueries(["orders-for-nft", nftId]);
        queryClient.invalidateQueries(["offers-for-nft", nftId]);
        queryClient.invalidateQueries(["purchase-history", nftId]);
        queryClient.invalidateQueries(["reserve-activities", nftId]);
        queryClient.invalidateQueries(["reserve-bids-for-nft", nftId]);
        queryClient.invalidateQueries(["auction", nftId]);
        queryClient.invalidateQueries(["collection-offer"]);
        queryClient.invalidateQueries(["received-offers"]);
        queryClient.invalidateQueries(["made-offers"]);
      }, delay);
    },
    [nftId, queryClient],
  );
}
